export default {
  categories: [],
  rootCategory: null,
  currentCategory: null,
  currentProduct: null,
  filter: [],
  selectedFilter: [],
};
